export default __webpack_public_path__ + "static/media/so.1642d33f.svg";